'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BasePopup = require('../Base/BasePopup');

var _BasePopup2 = _interopRequireDefault(_BasePopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _BasePopup2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree-select/lib/Popup/MultiplePopup.js
// module id = 929
// module chunks = 0 1